import { accountRoute } from './pages/account/Account.lazy.tsx';
import { adminRoute } from './pages/admin/Admin.lazy';
import { adminUserRoute } from './pages/admin-user/AdminUser.lazy.tsx';
import { adminUserListRoute } from './pages/admin-user-list/AdminUserList.lazy.tsx';
import { availabilitySlotRoute } from './pages/availability-slot/AvailabilitySlot.lazy.tsx';
import { calendarRoute } from './pages/calendar/Calendar.lazy';
import { chatHomeRoute } from './pages/chat-home/ChatHome.lazy.tsx';
import { connectedAccountsRoute } from './pages/connected-accounts/ConnectedAccounts.lazy.tsx';
import { dashboardFallbackRoute, dashboardRoute } from './pages/dashboard/Dashboard.lazy';
import { meetingRoute } from './pages/meeting/Meeting.lazy.tsx';
import { meetingRequestRoute } from './pages/meeting-request/MeetingRequest.lazy.tsx';
import { myProfileRoute } from './pages/my-profile/MyProfile.lazy';
import { notificationsRoute } from './pages/notifications/Notifications.lazy.tsx';
import { onboardImportRoute } from './pages/onboard-import/OnboardImport.lazy.tsx';
import { organizationRoutes } from './pages/organization/Organizations.lazy.tsx';
import { repMeetingConfirmFoodCategoryRoute } from './pages/rep-meeting-confirm-food-category/RepMeetingConfirmFoodCategory.lazy.tsx';
import { repMeetingEditRoute } from './pages/rep-meeting-edit/RepMeetingEdit.lazy.tsx';
import { repPublicProfileRoute } from './pages/representative-public-profile/RepresentativePublicProfile.lazy.tsx';
import { repsRoute } from './pages/reps/Representative.lazy.tsx';
import { settingsRoute } from './pages/settings/Settings.lazy';
import { staffRoute } from './pages/staff/Staff.lazy';
import { subscriptionRoute } from './pages/subscription/Subscription.lazy.tsx';
import { supportRoute } from './pages/support/Support.lazy.tsx';

export default [
  dashboardRoute,
  calendarRoute,
  adminRoute,
  myProfileRoute,
  connectedAccountsRoute,
  repsRoute,
  settingsRoute,
  staffRoute,
  accountRoute,
  meetingRoute,
  availabilitySlotRoute,
  meetingRequestRoute,
  repMeetingEditRoute,
  repMeetingConfirmFoodCategoryRoute,
  repPublicProfileRoute,
  adminUserRoute,
  adminUserListRoute,
  subscriptionRoute,
  notificationsRoute,
  chatHomeRoute,
  supportRoute,
  onboardImportRoute,
  organizationRoutes,
  dashboardFallbackRoute,
];
